import React, {useEffect, useRef, useState} from 'react';
import API from "../utils/API";
import {API_ENDPOINTS} from "../apiConfig";
import Forms from "./Forms";
import Error from "./Error";

const FIELD_TYPE_OPTIONS = [
    {value: 'enum', label: 'Enum'},
    {value: 'boolean', label: 'Boolean'},
    {value: 'number', label: 'Number'},
    {value: 'string', label: 'String'}
];

const PartParameterModal = ({close, onSaved, parameter}) => {
    const inputRef = useRef(null);
    const [error, setError] = useState(null);
    const [form, setForm] = useState({
        key: '',
        label: '',
        type: 'string',
        optionsText: '',
        unit: '',
        active: true
    });
    const isEdit = !!parameter?._id;

    useEffect(() => {
        setTimeout(() => inputRef.current?.focus(), 1);
    }, []);

    useEffect(() => {
        if (!parameter) return;
        setForm({
            key: parameter.key || '',
            label: parameter.label || '',
            type: parameter.type || 'string',
            optionsText: Array.isArray(parameter.options) ? parameter.options.join(', ') : '',
            unit: parameter.unit || '',
            active: parameter.active !== false
        });
    }, [parameter]);

    const submit = async (e) => {
        e.preventDefault();
        setError(null);
        try {
            const payload = {
                key: String(form.key || '').trim(),
                label: String(form.label || '').trim(),
                type: form.type,
                options: form.type === 'enum'
                    ? String(form.optionsText || '').split(',').map((v) => v.trim()).filter(Boolean)
                    : [],
                unit: String(form.unit || '').trim(),
                active: !!form.active
            };

            if (isEdit) {
                await API.put(API_ENDPOINTS.partParameter.edit(parameter._id), payload);
            } else {
                await API.post(API_ENDPOINTS.partParameter.add, payload);
            }
            await onSaved?.();
            close();
        } catch (err) {
            setError(err);
        }
    };

    return (
        <form onSubmit={submit}>
            <div className="grid grid-cols-2 gap-4">
                <Forms.Text label="Key" value={form.key} onChange={(v) => setForm((p) => ({...p, key: v}))} ref={inputRef}/>
                <Forms.Text label="Název" value={form.label} onChange={(v) => setForm((p) => ({...p, label: v}))}/>
                <Forms.Select
                    label="Datový typ"
                    value={FIELD_TYPE_OPTIONS.find((x) => x.value === form.type)}
                    options={FIELD_TYPE_OPTIONS}
                    onChange={(v) => setForm((p) => ({...p, type: v?.value || 'string'}))}
                />
                <Forms.Text label="Jednotka (volitelné)" value={form.unit} onChange={(v) => setForm((p) => ({...p, unit: v}))}/>
                <Forms.Checkbox label="Aktivní" checked={!!form.active} onChange={(v) => setForm((p) => ({...p, active: !!v}))}/>
                {form.type === 'enum' ? (
                    <div className="col-span-2">
                        <Forms.Text label="Enum hodnoty (oddělit čárkou)" value={form.optionsText} onChange={(v) => setForm((p) => ({...p, optionsText: v}))}/>
                    </div>
                ) : null}
            </div>
            {error ? <Error error={error}/> : null}
            <Forms.Button submit className="mt-4" label={isEdit ? 'Uložit parametr' : 'Vytvořit parametr'}/>
        </form>
    );
};

export default PartParameterModal;
